import UserDashboard from "../components/dashboard/UserDashboard";
function Dashboard() {


  return (
    <div>
      <UserDashboard/>
    </div>
  );
}

export default Dashboard;


